import i18n from "i18next";
import I18NextHttpBackend from "i18next-http-backend";
import Cookies from "js-cookie";
import { initReactI18next } from "react-i18next";

i18n
  .use(I18NextHttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: Cookies.get("currentLanguage"), // default language
    fallbackLng: "en", // fallback language if translation not found
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      // Path to the translation files
      loadPath: "/locales/{{lng}}.json",
    },
  });

export default i18n;
